import {
    GET_TEXT_QUESTION_LIST_FAILED,
    GET_TEXT_QUESTION_LIST_START,
    GET_TEXT_QUESTION_LIST_SUCCESS
} from '../../../constants';
import { BATCH_QUESTIONS_URL } from '../../../../../config/constants';
import { ApiBase } from '../../../../utils/apiBase';
import { withType } from '../../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const getTextQuestionList = (payload) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        dispatch(withType(GET_TEXT_QUESTION_LIST_START, {}));
        apiBaseInstance.instance
            .post(BATCH_QUESTIONS_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(GET_TEXT_QUESTION_LIST_SUCCESS, {
                    data: response.data,
                    message: response.message
                }));
            })
            .catch(err => {
                dispatch(withType(GET_TEXT_QUESTION_LIST_FAILED, {
                    error: err
                }));
            });
    };
};

